import { i18nInstance } from './i18n';
import { setDefaultOptions } from 'date-fns';
import dateLocales from '../constants/dateLocales';
import type { i18n as I18nInstance } from 'i18next';

// t returns any (consumer-forced loosening): legacy call sites assign t() results to null-initialized state/vars,
// which a string return breaks; the rest of the i18next surface stays typed
export type ReactifiI18n = Omit<I18nInstance, 't'> & { t: (...args: any[]) => any; loadTranslations: () => void };

// cast via unknown: loadTranslations is attached right below, and t is deliberately loosened (see ReactifiI18n)
const instance = i18nInstance().getInstance() as unknown as ReactifiI18n;

instance.loadTranslations = () => {
  if (typeof window === 'undefined') return;

  // casts: window.translations is an untyped host-page global (per-language resource bundles)
  if (Object.hasOwnProperty.call(window, 'translations') && Object.keys((window as any).translations).length !== 0) {
    Object.values((window as any).translations as Record<string, Record<string, any>>).forEach(translation => {
      Object.keys(translation).forEach(language => {
        instance.addResourceBundle(language, 'defaultNamespace', translation[language]);
      });
    });
  }

  // cast: language is a runtime-detected string key; dateLocales has a fixed key set (en fallback preserved)
  setDefaultOptions({ locale: dateLocales[instance.language as keyof typeof dateLocales] || dateLocales.en });
};

if (typeof window !== 'undefined') {
  instance.loadTranslations();
}

export const i18n = instance;
